module.exports = __webpack_public_path__ + "static/media/button1.bbd3a7e1.mp3";